// extracted by mini-css-extract-plugin
export default {"text":"text_button-module__text--3aVl_","content":"text_button-module__content--1OA8l"};